import "../../css/TimothyPwaIFrame.css"
import { useSelector } from "react-redux";

export default function TimothyPwaIFrame() {
    // eslint-disable-next-line no-unused-vars
    const { previewState } = useSelector((state) => state.WebchatBrandingElementsReducer);


    return(
        <div id="timothy-pwa-iframe">
            <iframe id="timothyPwaIFrame" src={"https://" + previewState.SubDomain + ".myblustream.io"} title="ChatStream Preview" />
        </div>
    );
}

